import React, { useEffect, useRef, useState } from "react";
import SumsubWebSdk from "@sumsub/websdk-react";
import {
  addApplicantApi,
  getProfile,
  kyc,
} from "../../Services/prod/auth.service";
import styled from "styled-components";
import Modal from "react-modal";
import './user-verification.css'
import Image from "../../components/image/image.component";
import { ReactComponent as CloseIcon } from "../../icons/close.svg";

const UserVerifi = ({setVerificarionOpen, getKYC}) => {
  // STATES
  const [token, setToken] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [kycStatus, setKycStatus] = useState(false);
  const [showSumsub, setShowSumsub] = useState(true);
  const [modalOpen, setModalOpen] = useState(true);
  
    const inactivityTimeoutRef = useRef(null);

    const closeModal = () => {
      setVerificarionOpen(false);
      setShowSumsub(false);
      if(getKYC){
        getKYC();
      }
    };
  
    const resetInactivityTimer = () => {
      if (inactivityTimeoutRef.current) {
        clearTimeout(inactivityTimeoutRef.current);
      }
  
      inactivityTimeoutRef.current = setTimeout(() => {
        closeModal();
      }, 300000); 
    };
  
    const detectInactivity = () => {
      window.addEventListener("mousemove", resetInactivityTimer);
      window.addEventListener("keydown", resetInactivityTimer);
      window.addEventListener("scroll", resetInactivityTimer);
    };
  
    useEffect(() => {
      resetInactivityTimer(); 
      detectInactivity(); 
      return () => {
        clearTimeout(inactivityTimeoutRef.current);
        window.removeEventListener("mousemove", resetInactivityTimer);
        window.removeEventListener("keydown", resetInactivityTimer);
        window.removeEventListener("scroll", resetInactivityTimer);
      };
    }, []);

    useEffect(() => {
      const handleVisibilityChange = () => {
        if (document.hidden) {
        }
      };
  
      document.addEventListener("visibilitychange", handleVisibilityChange);
  
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
      };
    }, []);

  // for sumsub token and kyc status
  const getToken = async (payload) => {
    try {
      const profileRes = await getProfile();
      setKycStatus(profileRes?.data?.kyc_status);
      if (payload?.reviewStatus === "pending") {
        setKycStatus("WaitingkycResponsse");
      }
      if (
        profileRes?.data?.kyc_status === "PENDING" ||
        profileRes?.data?.kyc_status === "REJECTED"
      ) {
        const tokenRes = await kyc();
        setToken(tokenRes?.data?.token);
      } else {
        setShowSumsub(false);
        setToken("");
      }
      setLoading(false);
      if(getKYC){
        getKYC();
      }
    } catch (error) {
      setLoading(false);
      setError(error.message || "An error occurred In Token & Prifile Section");
      console.log("error", error);
    }
  };

  useEffect(() => {
    getToken();
  }, []);

  // expirationHandler
  const handleExpireToken = async () => {
    try {
      const tokenRes = await kyc();
      setToken(tokenRes?.data?.token);
    } catch (error) {
      setError(error.message || "An error occurred In Token Api");
      console.log(error);
    }
  };
  const addApplicant = async (applicantId) => {
    try {
      const applicantPayload = { applicant_id: applicantId };
      const applicantRes = await addApplicantApi(applicantPayload);
    } catch (error) {
      setError(error.message || "An error occurred In Applicant Api");
      console.log(error, "error in applicantAPI");
    }
  };

  // for loading andd error
  if (loading) {
    return (
      <div style={{ textAlign: "center" }}>
        <h2>Loading...</h2>
      </div>
    );
  }
  if (error) {
    return (
      <div style={{ textAlign: "center" }}>
        <h2>Error: {error}</h2>
      </div>
    );
  }

  
  return (
   
    <div id="sumsub-websdk-container">
      {showSumsub && token ? (
        <>
          <Modal
            isOpen={modalOpen}
            // onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <Title className='title'>
              <Image src={'logo.png'} alt={'Music Bull'} width={100} />
              <h2>Welcome to MusicBull!</h2>
            </Title>

            <CMCloseButton onClick={closeModal}>
            <CloseIcon width={16} height={16} />
            </CMCloseButton>

            <SumsubWebSdk
              accessToken={token}
              expirationHandler={handleExpireToken}
              config={{theme: 'light'}}
              options={(data) => console.log(data)}
              onMessage={(type, payload) => {
                if (
                  type === "idCheck.onApplicantLoaded" ||
                  type === "idCheck.onApplicantCreated"
                ) {
                  addApplicant(payload.applicantId);
                  if(getKYC){
                    getKYC();
                  }
                } else if (type === "idCheck.onApplicantStatusChanged") {
                  getToken(payload);
                  if(getKYC){
                    getKYC();
                  }
                }
                console.log("onMessage", type, payload);
              }}
              onError={(data) => console.log(data, "onError")}
              onReady={(data) => console.log(data, "onRRReady")}
            />
          </Modal>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default UserVerifi;



const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    // marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "450px",
    borderRadius: 30,
    maxHeight: '85%',
    "@media(max-width: 575px)": {
      maxWidth: "300px",
    },
    "@media(max-width: 479px)": {
      maxWidth: "270px ! important",
    },
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    zIndex: 9999,
  },
};

const Title = styled.h2(() => {
  return ({
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    borderBottom: `solid 1px #a80000`,
    "& > h2": {
      fontWeight: 600,
      marginBottom: '10px',
      fontSize: "22px",
    },
  })
});

 const CMCloseButton = styled.div((props) => ({
  textAlign: "right",
  position: "absolute",
  right: 32,
  top: 28,
  cursor: "pointer",
}));

